import { BulkTemplateColKey } from './bulkTemplateRows'

/**
 * Columnas extra de la plantilla PRELLENADA de guías con error.
 *
 * No forman parte de la plantilla en blanco del flujo de creación, así que NO van en
 * `BULK_TEMPLATE_REQUIRED_HEADERS`: el parser arma su mapa con las cabeceras que encuentra
 * y nunca rechaza las que no conoce.
 *
 * Viven acá y no sueltas en la pantalla porque hay dos lados que tienen que coincidir
 * EXACTAMENTE: el que las escribe (`exportFormatoShipmentXLSX_V2WithCoords`) y el que las
 * lee al volver a subir el archivo (`ShipmentBulkUpload`, vía `col(raw, ...)`). Con el
 * texto duplicado a mano, un retoque de redacción en uno de los dos rompe el emparejado
 * sin ningún error visible: las filas simplemente dejarían de encontrar su guía.
 */

/** Motivo por el que falló la guía. Informativa, gris, la ignora el import. */
export const BULK_ERROR_REASON_HEADER = 'Motivo del error'

/** Identificador interno de la línea. Oculta; es la clave del emparejado al re-subir. */
export const BULK_LINE_ID_HEADER = 'ID de línea (no modificar)'

export interface BulkExtraColumn {
  key: BulkTemplateColKey
  header: string
  width?: number
  hidden?: boolean
  readOnly?: boolean
  note?: string
}

/**
 * Las columnas extra, en el orden en que se agregan después de "Observaciones".
 *
 * El ID va OCULTO a propósito: el operador no tiene nada que hacer con un GUID y una
 * columna visible llena de identificadores invita a que la borre "porque no sirve" —
 * justo lo que rompe el emparejado. Si la borra igual, el emparejado cae al nº de guía
 * aliada y se avisa.
 */
export const BULK_CORRECTION_EXTRA_COLUMNS: BulkExtraColumn[] = [
  {
    key: 'motivoError',
    header: BULK_ERROR_REASON_HEADER,
    width: 60,
    readOnly: true,
    note:
      'Informativa: por qué falló esta guía en la carga original. No se lee al volver a ' +
      'subir el archivo, podés dejarla como está. Ojo: si una guía ocupa varias filas ' +
      '(varias piezas), corregí los datos del destinatario en la PRIMERA fila — las ' +
      'demás solo aportan sus piezas.',
  },
  {
    key: 'lineId',
    header: BULK_LINE_ID_HEADER,
    width: 40,
    hidden: true,
    note:
      'No modificar ni borrar: es con esto que el sistema reconoce cada guía al volver a ' +
      'subir el archivo, incluso si le cambiás el número de guía aliada.',
  },
]
